import React from 'react';
import SkeletonComponent from './common/SkeletonComponent.jsx';

const ManageProjectContractSkeleton = () => {


  return (
    <div className='project-contract-container pb-4' style={{height: '100vh'}}>
      <h3 className="pt-1 pb-2">
        <SkeletonComponent variant='text' />
      </h3>
      <div>
        <SkeletonComponent variant='rounded' height={230} width='100%' />
      </div>

      <div className='pt-2'>
        <SkeletonComponent height={1000} width='100%' />
      </div>
    </div>
  )
}

export default ManageProjectContractSkeleton;